'use client'

import React from 'react'
import Link from 'next/link'

export interface SubNavigationItemProps {
    children: React.ReactNode
    href: string
    dataTestId?: string
}

export const SubNavigationItem = ({ children, href, dataTestId }: SubNavigationItemProps) => {
    return (
        <li className="a11y-outline main-navigation__subnavigation-item whitespace-nowrap min-w-full flex w-full text-left py-3 px-4 text-text-primary hover:bg-accent-opacity-100 active:bg-accent-opacity-200 focus-within:outline-2 focus-within:outline-accent-600 focus-within:rounded-xs">
            <Link href={href} className="w-full" data-testid={dataTestId ?? 'sub-menu-item'}>
                {children}
            </Link>
        </li>
    )
}
